import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import LazyImage from '../components/LazyImage';
import TrackedComponent from '../components/TrackedComponent';
import { useAnalytics } from '../hooks/useAnalytics';
import FAQSection from '../modules/faq/faq';
import FeatureSection from '../modules/feature/feature';
import InfoSection from '../modules/info/info';
import TimelineSection from '../modules/timeline/timeline';

const FinOpsPage = () => {
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();
  const imageUrl = t('screenshot_url');

  return (
    <>
      <SEO
        title={t('title')}
        description={t('finops_summary')}
        canonicalUrl="https://cloudsibyl.com/finops"
      />
      <main className="App-main">
        <div className="hero-block company-hero">
          <div className="hero-content">
            <h1 className="main-title">{t('title')}</h1>
            <p
              className="main-description"
              dangerouslySetInnerHTML={{ __html: t('description') }}
            />
          </div>
        </div>
        <section className="image-section">
          <div className="product-window">
            <div className="image-container">
              <LazyImage
                src={imageUrl}
                alt="CloudSibyl application screenshot showing cloud cost management dashboard"
                className="screenshot-image"
              />
            </div>
          </div>
        </section>
        <TrackedComponent sectionName="Cloud Challenges" trackScroll={true}>
          <InfoSection />
        </TrackedComponent>
        <TrackedComponent sectionName="CTA Section" trackScroll={true}>
          <section className="cta-section">
            <h2>{t('cta_title')}</h2>
            <p>{t('cta_subtitle')}</p>
            <Link
              to="/cloud-blind-spots"
              className="cta-button"
              onClick={() => trackEvent({
                category: 'Conversion',
                action: 'CTA Click',
                label: 'Download Guide - FinOps',
                value: 1
              })}
            >
              {t('cta_button')}
            </Link>
          </section>
        </TrackedComponent>
        <TrackedComponent sectionName="Features" trackScroll={true}>
          <FeatureSection />
        </TrackedComponent>
        <TrackedComponent sectionName="FAQ" trackScroll={true}>
          <FAQSection />
        </TrackedComponent>
        <TrackedComponent sectionName="Timeline" trackScroll={true}>
          <TimelineSection />
        </TrackedComponent>
      </main>
    </>
  );
};

export default FinOpsPage;
